import React, { useEffect, useState, useContext, useCallback } from "react";
import { AuthContext } from "../AuthContext";
import { useNavigate } from "react-router-dom";
import { Pencil, Trash2, ArrowRight } from "lucide-react";

import {
  createTable,
  getEventos,
  getTipos,
  getTables,
  updateTable,
  deleteTable
} from "../api";

export default function AddTables() {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  const [form, setForm] = useState({
    nome: "",
    evento_id: "",
    tipo_id: ""
  });

  const [editId, setEditId] = useState(null);

  const [eventos, setEventos] = useState([]);
  const [tipos, setTipos] = useState([]);
  const [tables, setTables] = useState([]);

  const [loading, setLoading] = useState(false);

  const [message, setMessage] = useState("");

  const loadTables = useCallback(async () => {
    const tb = await getTables(user.token);
    setTables(tb);
  }, [user.token]);

  useEffect(() => {
    async function load() {
      const ev = await getEventos(user.token);
      const tp = await getTipos(user.token);

      setEventos(ev);
      setTipos(tp);

      loadTables();
    }

    load();
  }, [user.token, loadTables]);

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      setLoading(true);

      if (editId) {
        await updateTable(editId, user.token, form);
        setMessage("Tabela atualizada com sucesso!");
      } else {
        await createTable(user.token, form);
        setMessage("Tabela criada com sucesso!");
      }

      setForm({ nome: "", evento_id: "", tipo_id: "" });
      setEditId(null);

      loadTables();

    } catch (err) {
      setMessage(err.message);
    } finally {
      setLoading(false);

      setTimeout(() => setMessage(""), 3000);
    }
  }

  function handleEdit(t) {
    setForm({
      nome: t.nome,
      evento_id: t.evento_id,
      tipo_id: t.tipo_id
    });

    setEditId(t.id);
  }

  async function handleDelete(id) {
    if (!window.confirm("Excluir tabela?")) return;

    try {
      await deleteTable(user.token, id);
      loadTables();
    } catch (err) {
      alert(err.message);
    }
  }

return (
  <div className="page-container">
    <div className="dashboard-container">
      <div className="user-card" style={{ maxWidth: "1000px", margin: "0 auto" }}>

        {/* Cabeçalho */}
        <div style={{ 
          justifyContent: "space-between", 
          alignItems: "center", 
          marginBottom: "2rem" 
        }}>
          <h3>{editId ? "Editando Tabela" : "Nova Tabela"}</h3>
        </div>

        {/* ==================== FORMULÁRIO ==================== */}
        <div className="item-row add-row" style={{ marginBottom: "2.5rem", gridTemplateColumns: "1fr 1fr 1fr auto" }}>

          {/* Nome da Tabela */}
          <div className="item-input" >
            <label>Nome da Tabela</label>
            <input
              className="form-control"
              name="nome"
              placeholder="Digite o nome da tabela"
              value={form.nome}
              onChange={handleChange}
            />
          </div>

          {/* Evento e Tipo */}
          <div className="item-input">
            <label>Evento</label>
            <select
              className="form-control"
              name="evento_id"
              value={form.evento_id}
              onChange={handleChange}
            >
              <option value="">Selecione um evento</option>
              {eventos.map(e => (
                <option key={e.id} value={e.id}>
                  {e.descricao}
                </option>
              ))}
            </select>
          </div>

          <div className="item-input">
            <label>Tipo</label>
            <select
              className="form-control"
              name="tipo_id"
              value={form.tipo_id}
              onChange={handleChange}
            >
              <option value="">Selecione um tipo</option>
              {tipos.map(t => (
                <option key={t.id} value={t.id}>
                  {t.descricao}
                </option>
              ))}
            </select>
          </div>

          {/* Botão Salvar */}
          <div className="item-actions">
            <button
              className="btn-small"
              onClick={handleSubmit}
              disabled={loading || !form.nome.trim() || !form.evento_id || !form.tipo_id}
            >
              {loading ? "Salvando..." : (editId ? "Atualizar Tabela" : "Cadastrar Tabela")}
            </button>
            {editId && (
              <button 
                type="button" 
                className="btn-small"
                onClick={() => {
                  setEditId(null);
                  setForm({ nome: "", evento_id: "", tipo_id: "" });
                }}
              >
                Cancelar Edição
              </button>
            )}
          </div>
        </div>

        {/* Mensagem de Feedback */}
        {message && (
          <div className="success-msg" style={{ marginBottom: "2rem" }}>
            {message}
          </div>
        )}

        {/* ==================== LISTA DE TABELAS ==================== */}
        <div style={{ marginTop: "2rem" }}>
          <h3 style={{ marginBottom: "1.5rem" }}>Tabelas Cadastradas</h3>

          {tables.length === 0 ? (
            <p style={{ 
              opacity: 0.7, 
              textAlign: "center", 
              padding: "3rem 0",
              fontSize: "1.05rem"
            }}>
              Nenhuma tabela cadastrada ainda.
            </p>
          ) : (
            <div className="items-list">
              {tables.sort((a, b) => b.id - a.id).map((t) => (
                <div 
                  key={t.id} 
                  className="item-row"
                  style={{
                    background: editId === t.id ? "rgba(59, 130, 246, 0.12)" : undefined,
                    border: editId === t.id ? "1px solid #3b82f6" : undefined,
                    gridTemplateColumns: "2fr 2fr auto"
                  }}
                >
                  <div className="item-input">
                    <label>Nome</label>
                    <input value={t.nome} disabled />
                  </div>

                  <div className="item-input">
                    <label>Evento • Tipo</label>
                    <input value={`${t.evento} - ${t.tipo}`} disabled />
                  </div>

                  <div className="item-actions">
                    <button
                      className="btn-small"
                      onClick={() => navigate(`/tableitems/${t.id}`)}
                      title="Ver Itens da Tabela"
                    >
                      <ArrowRight size={18} />
                    </button>

                    <button
                      className="btn-small"
                      onClick={() => handleEdit(t)}
                      title="Editar Tabela"
                    >
                      <Pencil size={18} />
                    </button>

                    <button
                      className="btn-danger btn-small"
                      onClick={() => handleDelete(t.id)}
                      title="Excluir Tabela"
                    >
                      <Trash2 size={18} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

      </div>
    </div>
  </div>
);

}